<template>
  <div class="photo-viewer">
    <viewer  :images="images" @inited="inited" :options="options">
      <img v-for="(src,index) in images" :src="src" :key="index" style="opacity:0;display:none" ref="viewer">
    </viewer>
  </div>
</template>

<script>
    import Vue from 'vue'
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    Vue.use(Viewer)
    
    export default {
        name:'photo-viewer',
        props:{
            images:{
                type:Array,
                default:()=>{return []}
            },
            options:{
                type:Object,
                default:()=>{
                    return {}
                }
            }
        },
        watch:{
            images:{
                handler(newVal){
                    this.images = newVal;
                },
                deep:true
            }
        },
        methods:{
            inited (viewer) {
                this.$emit('inited',viewer);
            },
        }
    }
</script>

<style lang="less" scoped>

</style>
